export enum RecommendationType {
    LastSeenProducts = 'LastSeenProducts',
    BestSeller = 'BestSeller',
    Category = 'Category',
    ProductCategory = 'ProductCategory',
    MainCategories = 'MainCategories',
    RelatedProducts = 'RelatedProducts',
}
